/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  REQUEST_DISCOVERY,
  FETCH_DISCOVERY_SUCCESS,
  FETCH_DISCOVERY_FAILURE,
  REQUEST_POST_DISCOVERY,
  POST_DISCOVERY_FAILURE,
  POST_DISCOVERY_SUCCESS
} from './actionTypes';
import { isEqual } from '../../utils/lodash-utils';

const discovery = (state = {
  isFetching: false,
  isPosting: false,
  didInvalidatePost: false,
  didInvalidate: false,
  items: []
}, action) => {
  switch (action.type) {
    case REQUEST_DISCOVERY:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case REQUEST_POST_DISCOVERY:
      return Object.assign({}, state, {
        isPosting: true,
        didInvalidatePost: false
      });
    case FETCH_DISCOVERY_SUCCESS:
      const items = action.discovery
      let updatedState = Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: items
      });
      return isEqual(updatedState, state) ? state : updatedState
    case POST_DISCOVERY_SUCCESS:
       updatedState = Object.assign({}, state, {
        isPosting: false,
        didInvalidatePost: false
      });
      return isEqual(updatedState, state) ? state : updatedState
    case FETCH_DISCOVERY_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: true,
        errorMessage: action.errorMessage,
      });
    case POST_DISCOVERY_FAILURE:
      return Object.assign({}, state, {
        isPosting: false,
        didInvalidatePost: true,
        postErrorMessage: action.errorMessage
      });
    default:
      return state
  }
};

export default discovery
